module.exports = __webpack_public_path__ + "static/media/Sarah S.1dc8021b.jpeg";